import React from "react";
import './Landing.css';
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Landing = () => {

    const navigate = useNavigate();

    // Function to handle navigation
    const handleRedirect = () => {
     navigate("/contact-us");
   };

  return (
    <div className="infra-landing-container">
      <div className="infra-landing-content">
        <h1 className="infra-landing-heading">Infrastructure Monitoring
        </h1>
        <p className="infra-landing-description">Discover innovative cybersecurity solutions meticulously engineered to detect and prevent breaches. 
        </p>
        <Button variant="contained" className="ctaBtn" onClick={handleRedirect}>Connect With Us Today</Button>
      </div>
    </div>
  )
}

export default Landing;